/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Merge_TextInputs */



/**
* | output |
* | --- |
* | "Merge Text" |
*
* @param {Event_Group_Options_Merge_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_merge_text = /** @type {((inputs?: Event_Group_Options_Merge_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Merge_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fusionner le texte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Text zusammenführen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Unisci testo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Объединить текст")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fusionar texto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("合并文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキストの結合")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेक्स्ट मर्ज करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mesclar texto")
	return /** @type {LocalizedString} */ ("Merge Text")
});